var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4183 0.325195H3.45127C1.86714 0.325195 0.583008 1.60933 0.583008 3.19346V33.8051C0.583008 35.3864 1.86714 36.6706 3.45127 36.6706H35.905C36.9284 36.6706 37.876 37.2173 38.3863 38.1061L39.6985 40.3743L41.1789 42.9398C42.2808 44.852 45.0397 44.852 46.1444 42.9398L47.6248 40.3743L48.9341 38.1061C49.4472 37.2173 50.3949 36.6706 51.4183 36.6706C52.2118 36.6706 52.9267 36.3509 53.4454 35.8294C53.9669 35.3135 54.2866 34.5958 54.2866 33.8051V3.19346C54.2866 1.60933 53.0024 0.325195 51.4183 0.325195ZM23.703 28.4415C23.703 24.7994 29.204 24.7994 29.204 28.4415C29.204 32.0499 23.703 32.0499 23.703 28.4415ZM30.0619 20.9133C29.1339 21.533 28.7554 22.4947 28.7554 24.1096V24.2835H24.2188V24.076C24.2553 19.3685 26.1787 18.303 28.0011 17.3385C29.8236 16.3768 31.918 16.102 31.918 14.0385C31.918 11.3945 29.4787 10.7749 27.3479 10.7749C25.1469 10.7749 22.8786 12.0113 22.845 14.1759H18.2384C18.2748 9.0898 22.5702 6.82155 27.4152 6.82155C32.2629 6.82155 36.7321 8.91877 36.6284 14.0749C36.6284 19.0572 32.0554 19.5731 30.0619 20.9133Z",
    fill: "#E8E7E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.32f3ae8ceff67b7752fcc061dc952c59.svg";
export { ForwardRef as ReactComponent };